/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useRef, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { DataDashboardResponse } from "../types/DashboardType";

type Response = {
  payload: DataDashboardResponse;
  pagination_data: null;
};

export const useDashboardList = (project_id: number) => {
  const api = useApi();
  const hasFetched = useRef(false);
  const params={ project_id: project_id }

  const [data, setData] = useState<DataDashboardResponse>({ budget: [], milestone: [], payment: [] });
  const [isLoading, setLoading] = useState(true);

  const fetchData = () => {
    setLoading(true);

    api.get("project/get_project_dashboard",{params})
    .then((res: SuccessFetch<Response>) => setData(res.data.payload ?? null))
    .catch(() => setData({ budget: [], milestone: [], payment: [] }))
    .finally(() => setLoading(false));
  };

  const refetch = () => fetchData();

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    fetchData();

    return () => {
      setData({ budget: [], milestone: [], payment: [] });
    };
    // eslint-disable-next-line
  }, []);

    return { data, isLoading, refetch };
}
